module.exports = __webpack_public_path__ + "static/media/341.301af75f.png";